/*
 * @Author: wangyaofeng 1158983938@qq.com
 * @Date: 2026-02-12 15:56:58
 * @LastEditors: wangyaofeng 1158983938@qq.com
 * @LastEditTime: 2026-02-12 16:47:35
 * @Description: 请输入文件描述
 */
import { createRouter, createWebHashHistory } from 'vue-router'

import { layoutChildren } from './routeList'

const routes = [
  {
    path: `/layout`,
    component: () => import(`@/components/layout/AppLayout.vue`),
    children: layoutChildren,
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, top: 80, behavior: `smooth` }
    }
    if (savedPosition) return savedPosition
    if (to.name === `Products` && to.query.product !== undefined) {
      // 同页面内切换产品：不自动滚动，由组件负责滚到轮播区
      if (from.name === `Products`) return false
      // 从其他页跳转过来：先滚到顶，再由组件滚到轮播区
      return { top: 80 }
    }
    return { top: 0 }
  },
})

export default router
